import {
    GET_DATAENTRY_PLANTS,
    GET_DATAENTRY_PLANTS_SUCCESS,
    GET_DATAENTRY_PLANTS_FAIL,
    GET_DATAENTRY_ANIMALS,
    GET_DATAENTRY_ANIMALS_SUCCESS,
    GET_DATAENTRY_ANIMALS_FAIL,
    ADD_DATAENTRY_PLANT,
    ADD_DATAENTRY_PLANT_SUCCESS,
    ADD_DATAENTRY_PLANT_FAIL,
    ADD_DATAENTRY_ANIMAL,
    ADD_DATAENTRY_ANIMAL_SUCCESS,
    ADD_DATAENTRY_ANIMAL_FAIL,
    GET_LEADERBOARD,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAIL
} from "./actionTypes"


export const getDataEntryPlants = () =>  {
  console.log("sdfsdfsdf")
  return {
  type: GET_DATAENTRY_PLANTS,
}}

export const getDataEntryPlantsSuccess = plants => ({
  type: GET_DATAENTRY_PLANTS_SUCCESS,
  payload: plants,
})

export const getDataEntryPlantsFail = error => ({
  type: GET_DATAENTRY_PLANTS_FAIL,
  payload: error,
})

export const getDataEntryAnimals = () => ({
  type: GET_DATAENTRY_ANIMALS,
})

export const getDataEntryAnimalsSuccess = animals => ({
  type: GET_DATAENTRY_ANIMALS_SUCCESS,
  payload: animals,
})

export const getDataEntryAnimalsFail = error => ({
  type: GET_DATAENTRY_ANIMALS_FAIL,
  payload: error,
})

export const getLeaderboard = () => ({
  type: GET_LEADERBOARD,
})

export const getLeaderboardSuccess = leaderboard => ({
  type: GET_LEADERBOARD_SUCCESS,
  payload: leaderboard,
})

export const getLeaderboardFail = error => ({
  type: GET_LEADERBOARD_FAIL,
  payload: error,
})

export const addDataEntryPlant = (plant) => {
  console.log(plant)
  return {
  type: ADD_DATAENTRY_PLANT,
  payload: plant
}}

export const addDataEntryPlantSuccess = (plant) => ({
  type: ADD_DATAENTRY_PLANT_SUCCESS,
  payload: plant
})

export const addDataEntryPlantFail = error => ({
  type: ADD_DATAENTRY_PLANT_FAIL,
  payload: error,
})

export const addDataEntryAnimal = (animal) => ({
  type: ADD_DATAENTRY_ANIMAL,
  payload: animal
})

export const addDataEntryAnimalSuccess = (animal) => ({
  type: ADD_DATAENTRY_ANIMAL_SUCCESS,
  payload: animal
})

export const addDataEntryAnimalFail = error => ({
  type: ADD_DATAENTRY_ANIMAL_FAIL,
  payload: error,
})
